import React from "react";
import {observable, toJS} from "mobx";
import {sortCaret} from "../../comum/components/Icones";
import {
    appendFieldSpan,
    situacaoFormatter,
    splitBR,
    formatarDataCustomHTML
} from "../../../utils/formatar";
import LoadingImage from "../../comum/components/LoadingImage";
import {buscaFiltrarVazio, buscaSemResultado} from "../../../utils/mensagens";

export default class OswebStore {
    estadoFiltros;

    @observable oswebLista;

    @observable listaMensagens;

    @observable inserindoXml;

    @observable posEditando;
    estadoEditando;

    @observable mensagemErro;
    @observable sucesso;
    @observable sucessoMsg;

    // Scroll infinito
    @observable lista;
    @observable items;
    toShow;
    turn;
    @observable hasMore;
    @observable noData;
    @observable linhaExpandida;
    @observable tableMessage;
    @observable loading;

    // Area de inclusão
    @observable inserindo;
    @observable sucessoInserirOsweb;
    @observable salvando;

    @observable solicitantes;
    @observable tipos;
    @observable servicos;
    @observable motivos;
    @observable loadingSolicitantes;
    @observable loadingTipos;
    @observable loadingServicos;
    @observable loadingMotivos;
    // FIM Area de inclusão

    constructor(service) {
        this.estadoFiltros = false;

        this.oswebLista = [];
        this.listaMensagens = false;

        this.posEditando = -1;
        this.estadoEditando = {};

        this.colunas = this.todasColunas;

        this.mensagemErro = ""
        this.sucesso = false;
        this.sucessoMsg = "";

        // Scroll infinito
        this.lista = [];
        this.toShow = 20;
        this.turn = 0;
        this.items = [];
        this.hasMore = false;
        this.noData = <LoadingImage />;
        this.tableMessage = buscaFiltrarVazio;
        this.loading = false;

        // Area de inclusão
        this.inserindo = false;
        this.sucessoInserirOsweb = false;
        this.salvando = false;

        this.solicitantes = [];
        this.tipos = [];
        this.servicos = [];
        this.motivos = [];
        this.loadingSolicitantes = true;
        this.loadingTipos = true;
        this.loadingServicos = true;
        this.loadingMotivos = true;
        // FIM Area de inclusão

        this.service = service;
        this.listarSolicitantes()
        this.listarTipos()
    };

    // Area lisgatem
    listar(filtros) {
        this.estadoFiltros = Object.assign({}, filtros);
        this.fazerListar(filtros);
    };

    reListar = () => {
        this.fazerListar(this.estadoFiltros);
    };

    fazerListar = (filtros) => {
        this.oswebLista = [];
        this.lista = [];
        this.items = [];
        this.loading = true;
        this.service.listar(filtros.osId, filtros.status, filtros.cntr, filtros.situaOS, filtros.docCodCntrOuNf).then(response => {
            if (response.data) {
                this.oswebLista = response.data;
            }
            if(this.oswebLista.length === 0) {
                this.tableMessage = buscaSemResultado
            } else {
                this.tableMessage = buscaFiltrarVazio
            }
            this.lista = this.oswebLista;

            this.noData = this.tableMessage;
            this.loadFirstTurn();
            
        }).catch(err => console.log(err)
        ).finally(() => this.loading = false)
    };

    loadFirstTurn = () => {
        this.items = this.oswebLista.slice(0, this.toShow);
        this.turn = 1;
        this.hasMore = this.items.length < this.lista.length;
    };

    loadNextTurn = () => {
        this.items = [];
        this.items = this.lista.slice(0, (this.turn+1)*this.toShow);
        this.turn = this.turn+1;

        this.hasMore = this.items.length < this.lista.length;
    };
    // Fim Area listagem

    listarSolicitantes = () => {
        
        this.service.listarSolicitantes().then(response => {
            if(response && response.data){
                response.data.map(solicitante => {
                    this.solicitantes.push({label: solicitante.RazaoSocial, value: solicitante.DspId})
                })
            }
        }).catch(err => console.log(err))
    }

    listarTipos = () => {
        this.service.listarTipos().then(response => {
            if(response && response.data){
                response.data.map(tipo => {
                    this.tipos.push({label: tipo.RvMeaning,value: tipo.Id.RvLowValue})
                })
            }
        }).catch(err => console.log(err))
    }

    // Area incluão
    incluirOsweb = (novaOsweb) => {
        this.salvando = true
        this.service.salvar(novaOsweb).then(response => {
            if(!response.data.Sucesso) 
            {
                this.sucessoMsg = "";
                this.mensagemErro = response.data.Mensagem;
            }
            else {
                this.mensagemErro = ""
                this.sucesso = true
                this.sucessoMsg = response.data.Mensagem;
                this.inserindo = false
            }
        }).catch(err => console.log(err)
        ).finally(() => {
            this.salvando = false
        })
    };

    cancelarInclusao = () => {
        this.inserindo = false;
        this.mensagemErro = ""
        this.posEditando = -1;
    };
    // Fim Area inclusão

    fecharModalSucesso = () => {
        this.sucesso = false;
        this.reListar();
    }

    // Exportar
    getLista() {
        return this.oswebLista;
    }

    getListaCopia() {
        return toJS(this.oswebLista)
    }
    // Fim Exportar

    todasColunas = [{
        dataField: 'OsId',
        text: 'OS',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'Id',
        text: 'Nº Pedido',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'DataSolicitacao',
        text: 'Pedido',
        sort: true,
        sortCaret: sortCaret,
        formatter: formatarDataCustomHTML,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'TipoOsweb',
        text: 'Tipo',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'Documento',
        text: 'Doc',
        style:{maxWidth:'180px', overflowWrap: 'break-word'},
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'Cntr',
        text: 'Container',
        sort: true,
        formatter: appendFieldSpan,
        formatExtraData: 'Operacao',
        style:{maxWidth:'150px', overflowWrap: 'break-word'},
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'Nf',
        text: 'Nf',
        sort: true,
        formatter: appendFieldSpan,
        style:{maxWidth:'150px', overflowWrap: 'break-word'},
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'DscTipoServico',
        text: 'Serviço',
        sort: true,
        style:{maxWidth:'150px', overflowWrap: 'break-word'},
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'SituacaoOs',
        text: 'Situação',
        headerStyle: () => { return { maxWidth: "60px" }; },
        formatter: situacaoFormatter,
        sort: true,
        sortCaret: sortCaret,
    }];
}


// WEBPACK FOOTER //
// ./src/modules/osweb/stores/OswebStore.js